import { App, ThemeConfig } from 'antd';
import { MessageInstance } from 'antd/es/message/interface';
import { NotificationInstance } from 'antd/es/notification/interface';
import { notification } from 'antd';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { getEnvSettings } from "../app/hostBasedSettings";
import { selectAuth } from "../redux/slices/authSlice";
import useTimeFormatters from './useTimeFormatters';

export interface EmailFragmentBaseProps {
  apiBaseUrl: string;
  token: string;
  theme: ThemeConfig;
  businessUnitId: string | null;
  messageApi: MessageInstance;
  notificationApi: NotificationInstance;
  formattingApi: {
    formatDate(date: string | Date): string;
    formatTime(date: string | Date): string;
    formatDateTime(date: string | Date): string;
    formatTimeSpan(seconds: number): string;
  };
}

export interface EmailFragmentExpandedProps {
  expanded: boolean;
  onExpandedChangeRequested(expanded: boolean): void;
  onExtraHeightRequested(): void;
}

export interface EmailFragmentFocusProps {
  isFocused: boolean;
  onFocusRequested(): void;
}

export default function useFragmentBaseProps(businessUnitId: string | null): EmailFragmentBaseProps {
  const { token } = useSelector(selectAuth);
  const language = 'en-UK';
  const { message } = App.useApp();
  const notificationApi = notification;
  const envSettings = getEnvSettings();
  const apiBaseUrl = envSettings.apiBaseURL;
  const formattingApi = useTimeFormatters();

  const fragmentBaseProps = useMemo<EmailFragmentBaseProps>(
    () => ({
      apiBaseUrl,
      token,
      theme: {
        token: {
          colorPrimary: '#326EC2',
          colorPrimaryTextHover: '#133575',
          colorPrimaryText: '#091F4F',
        }
      },
      language,
      businessUnitId,
      messageApi: message,
      notificationApi,
      formattingApi,
    }),
    [apiBaseUrl, formattingApi, businessUnitId, language, message, notificationApi,token],
  );

  return fragmentBaseProps;
}